import { READING_DARK_MODE_COOKIE } from '#shared/cookies'
// Lifecycle hooks run at page-swap time, avoiding pre-swap restyling.
// Use `router.currentRoute`, not `useRoute()`, so unmount resolves the
// destination route rather than the leaving one.
export function useReadingModeSync() {
  const colorMode = useColorMode()
  const hasLicense = useHasLicense()
  const readingDarkMode = useCookie(READING_DARK_MODE_COOKIE, READING_DARK_MODE_COOKIE_OPTIONS)
  const router = useRouter()

  function apply() {
    const route = router.currentRoute.value
    const preference = resolveReadingPreference(route.path, route.hash, hasLicense.value && readingDarkMode.value)
    if (colorMode.preference !== preference) {
      colorMode.preference = preference
    }
  }

  onMounted(apply)
  onUnmounted(apply)
}
